// For why this exists, see answers here:
// https://stackoverflow.com/questions/53605759/react-setting-state-to-an-es6-map
//
// TO CONSIDER: Switching to Rooks instead:
// https://react-hooks.org/docs/useMapState

import { useCallback, useState } from 'react';

// Similar to useObjectState, but wraps Map() instead of {}
export function useMapState<T extends string | number | symbol, S>(
  initialMapValue: Map<T, S>
): [Map<T, S>, (key: T, value: S) => void, (key: T) => void, () => void] {
  const [myMap, setMyMap] = useState<Map<T, S>>(initialMapValue);

  const setKey = useCallback((key: T, value: S): void => {
    setMyMap((currentMap) => {
      if (currentMap.get(key) !== value) {
        return new Map(currentMap.set(key, value));
      }
      return currentMap;
    });
  }, []);

  const removeKey = useCallback((key: T) => {
    setMyMap((currentMap) => {
      if (currentMap.has(key)) {
        const newMap = new Map(currentMap);
        newMap.delete(key);
        return newMap;
      }
      return currentMap;
    });
  }, []);

  const clear = useCallback(() => {
    setMyMap((currentMap) => {
      return new Map();
    });
  }, []);

  return [myMap, setKey, removeKey, clear];
}
